export default __webpack_public_path__ + "static/media/156216822_443181553628481_8812268014881472055_n.b0e174a3.jpg";